import React, { useEffect, useState, useRef } from 'react';

interface LedTimeCounterProps {
  isRunning?: boolean;
  isRecording?: boolean;
  initialSeconds?: number;
  isFullscreen?: boolean;
  resetNonce?: number;
}

const LedTimeCounter: React.FC<LedTimeCounterProps> = ({
  isRunning = false,
  isRecording = false,
  initialSeconds = 0,
  isFullscreen = false,
  resetNonce = 0,
}) => {
  const [totalSeconds, setTotalSeconds] = useState(initialSeconds);
  const animationFrameRef = useRef<number | null>(null);
  const lastTimeRef = useRef<number | null>(null);

  useEffect(() => {
    if (isRunning) {
      const tick = (timestamp: number) => {
        if (!lastTimeRef.current) lastTimeRef.current = timestamp;
        const delta = timestamp - lastTimeRef.current;
        if (delta >= 1000) {
          setTotalSeconds(prev => prev + 1);
          lastTimeRef.current = timestamp;
        }
        animationFrameRef.current = requestAnimationFrame(tick);
      };
      animationFrameRef.current = requestAnimationFrame(tick);
    } else {
      if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
      lastTimeRef.current = null;
    }

    return () => {
      if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
    };
  }, [isRunning]);

  useEffect(() => {
    if (resetNonce === 0) return
    setTotalSeconds(0)
    lastTimeRef.current = null
  }, [resetNonce])

  const formatTime = (secs: number) => {
    const mins = Math.floor(secs / 60);
    const seconds = secs % 60;
    const m = String(mins).padStart(2, '0');
    const s = String(seconds).padStart(2, '0');
    return `${m}.${s}`;
  };

  const handleClick = () => {
    setTotalSeconds(0);
  };

  return (
    <div
      className={`lcd-clock ${isRecording ? 'recording' : ''}`}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      {formatTime(totalSeconds)}
    </div>
  );
};

export default LedTimeCounter;
